import * as fileTypes from '../constants/fileTypes';

export const getFileTypeText = (type) => {
  switch (type) {
    case fileTypes.TRUE_PDF:
      return 'True PDF';
    case fileTypes.IMAGE:
      return 'Image';
    default:
      return 'Image PDF';
  }
};
